import { Component } from '@angular/core';

@Component({
    selector: 'gl-banner-details-page',
    templateUrl: './banner-details-page.component.html',
    styleUrls: ['./banner-details-page.component.scss']
})
export class BannerDetailsPageComponent {}
